import script from "./ProduitsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProduitsView.vue?vue&type=script&setup=true&lang=js"

import "./ProduitsView.vue?vue&type=style&index=0&id=f4705728&lang=scss&scoped=true"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4705728"]])

export default __exports__